<template>
  <div class='page_middle_container assignLeader_container' v-loading.fullscreen.lock="loadingData">
    <div class='page_middle_title'>
      {{`跨部门项目Leader页面-${department}`}}
      <!-- <i class='el-icon-close page_middle_close' @click='doClose' v-if="query.id == undefined"></i> -->
    </div>
    <div class='projectAssignLeader_page_middle_content'>
      <div style="width: 100%;">
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key'><span
                class="page_middle_row_key_required">*</span>项目号：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input disabled v-model.trim="data.project_number" placeholder="请输入项目号"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key'><span
                class="page_middle_row_key_required">*</span>需求名称：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input :disabled="true" v-model.trim="data.demand_name" placeholder="请输入需求名称"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key' style="text-align: right;"><span
                class="page_middle_row_key_required">*</span>需求编号：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input :disabled="true" v-model.trim="data.demand_number" placeholder="请输入需求编号"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key' @click="show = !show"><span
                class="page_middle_row_key_required">*</span>需求类型：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              
              <el-select class="leader_select" :disabled="true" v-model="data.task_type" placeholder="需求类型">
                <el-option v-for="(item, index) in config.projectType" :key="index" :value="item.index" :label="item.label"></el-option>
              </el-select>

              <!-- <el-radio-group :disabled="true" v-model="data.task_type">
                <el-radio v-for="(item, index) in config.projectType" :key="index" :label="index" size="small">
                  {{ item }}</el-radio>
              </el-radio-group> -->
              <div style="margin-left: 4vw;" v-if="data.task_type != 0 && !$tools.isNewProjectExe(this.created_time)">
                <el-button type="primary" @click="show = !show" size="small">{{ show ? "点击收起" : "点击展开" }}</el-button>
              </div>
            </div>
          </div>
        </div>
        <el-collapse-transition>
          <component v-show="show" v-if="components" v-bind:is="components" ref="project_execute_components" :isWatch="true"
            :subTaskData="subTaskData" :taskType="cacheTaskType"></component>
        </el-collapse-transition>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block" style="align-items: flex-start;">
            <div class='projectExecuteComponents_page_middle_row_key'>需求说明：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <div style="border: 1px solid #ccc;word-break: break-all;width: 100%;">
                  <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor['requirement']" :defaultConfig="toolbarConfig"
                      :mode="mode" />
                  <Editor style="height: 300px; overflow-y: hidden;" v-model="data.requirement"
                      :defaultConfig="editorConfig" :mode="mode" @onCreated="(editor)=>{onCreated(editor,'requirement')}" />
              </div>
              <!-- <el-input :disabled="true" type="textarea" v-model="data.requirement" rows="4"
                placeholder="请输入需求补充说明"></el-input> -->
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row' style="margin-bottom: 0;">
          <div class="project_execute_middle_row_block" style="align-items:flex-start">
            <div class='page_middle_row_attachment_key'
              style="height: 10vw;display: flex;flex-direction: column;justify-content: center; align-items: flex-end;">附件：
            </div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <Attachment class="zIndexBold" @changeFile="changeFile" @deleteFile="deleteFile" :isLink=true
                :showUpload="false" :files="requirement_attachment" type="project" :required="config.isRequired">
              </Attachment>
            </div>
          </div>
        </div>
        <div class="projectAssignLerder_table" v-if="data.leaders.length > 0">
          <div class="projectAssignLerder_table_tr">
            <div class="projectAssignLerder_table_leader">Leader类型</div>
            <div class="projectAssignLerder_table_name">姓名</div>
            <div class="projectAssignLerder_table_remark">备注</div>
            <div class="projectAssignLerder_table_controls">操作</div>
          </div>
          <div class="projectAssignLerder_table_tr" v-for="(leaders, index) in data.leaders" :key="index">
            <div class="projectAssignLerder_table_leader">
              <el-select :disabled="!isPrincipal" v-model="leaders.leader_type"
                placeholder="Leader类型">
                <el-option v-for="(department, index) in config.department" :key="index" :value="Number(department.department_id)"
                  :label="department.department"></el-option>
              </el-select>
            </div>
            <div class="projectAssignLerder_table_name">
              <el-select :disabled="!isPrincipal"
                v-model="leaders.user_id" filterable placeholder="Leader姓名">
                <el-option v-for="(staff, index) in config.staff_list" :key="index" :value="staff.id"
                  :label="staff.name"></el-option>
              </el-select>
            </div>
            <div class="projectAssignLerder_table_remark">
              <el-input :disabled="!isPrincipal" v-model.trim="leaders.remark"
                placeholder="请输入备注"></el-input>
            </div>
            <div class="projectAssignLerder_table_controls">
              <div class="add_operation_icon">
                <el-icon @click="addLeader">
                  <CirclePlusFilled />
                </el-icon>
              </div>
              <div class="del_operation_icon">
                <el-icon v-if="data.leaders.length>1" @click="delLeader(index)">
                  <RemoveFilled />
                </el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='page_middle_buttongroup' v-if="isPrincipal&&data.leaders.length > 0">
        <el-button type="primary" @click="doSendEmail()" :loading="loadingData" size="small">发送</el-button>
      </div>
      <!-- <div class="global_value_mask"></div> -->
    </div>
  </div>
</template>
<script>
import { CirclePlusFilled, RemoveFilled } from "@element-plus/icons";
import Attachment from "@/components/unit/attachment";
//平台综合类
import platformSynthesis from "@/components/page/project/projectExecuteComponents/platformSynthesis";
import medicalMaterials from "@/components/page/project/projectExecuteComponents/medicalMaterials";
import visualizationTask from "@/components/page/project/projectExecuteComponents/visualizationTask";
import projectExecuteTask from "@/components/page/project/projectExecuteComponents/projectExecuteTask";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { ElCollapseTransition } from "element-plus";
export default {
  name: 'page_middle',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    components() {
      // return "platformSynthesis"
      return this.$tools.isNewProjectExe(this.created_time)?"platformSynthesis":this.config.projectComponent[this.data.task_type];
    }
  },
  components: {
    Editor,
    Toolbar,
    Attachment,
    platformSynthesis,
    medicalMaterials,
    visualizationTask,
    projectExecuteTask,
    RemoveFilled,
    CirclePlusFilled,
    ElCollapseTransition,
  },
  data() {
    return {
      data: {
        project_id: '',
        project_number: "",
        demand_name: "",
        demand_number: "",
        task_type: 6,
        requirement: "",
        requirement_attachment: "",
        is_send: 0,
        leaders: []
      },
      config: {
        department:{},
        staff_list:[],
        allDepartment: {
          0:"开发/数据",
          1:"医学",
          2:"设计",
          3:"项目执行",
          4:"AIGC工具/文献整理/数据",
          5:"医学研究",
        },
        defaultLeader: {
          0:"袁振华",
          1:"李露薇",
          2:"罗冠明",
          3:"罗冠明",
          4:"高源",
          5:"金总",
          6:"袁振华",
          7:"李露薇",
          8:"黄相菊",
          9:"罗冠明"
        },//部门负责人与上方部门一一对应
        projectComponent: [
          "platformSynthesis",
          "medicalMaterials",
          "visualizationTask",
          "projectExecuteTask",
          "platformSynthesis",
          "platformSynthesis"
        ],
        newProjectComponent: [
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis"
        ],
        projectType:this.$config.types.newProjectDemandType,
        isRequired: {
          isRequired: false,
          title: "",
        },
      },
      toolbarConfig: this.$config.toolbarConfig,
      mode: 'default', // or 'simple'
      editorConfig: { placeholder: '请输入内容...' },
      editor: {
        requirement:null
      },
      created_time:"",
      show: true,
      department: "",//部门
      cacheTaskType: -1,
      subTaskData: {},
      isWatch: false,
      isPrincipal:false,//是否是负责人
      loadingData: false,
      requirement_attachment: [],
    }
  },
  created() {
    this.query = { ...this.$route.query };
    //leader_type就是部门
    this.department = isNaN(Number(this.query.leader_type)) ? "" : this.config.allDepartment[Number(this.query.leader_type)];
    this.config.department = [{
      department_id:Number(this.query.leader_type),
      department:this.department
    }];//跨部门页面只能选择本部门
    this.isPrincipal = !this.query.isWatch;//负责人可修改，isWatch为空或者没有
    this.isWatch = !!this.item.isWatch;
    let id = this.query.id == undefined ? this.item.operation_table_id : this.query.id;
    this.loadStaff();
    this.loadData(id);
  },
  mounted() {
  },
  methods: {
    //获取leader列表
    loadStaff() {
      return new Promise((resolve, reject) => {
        this.loadingData = true;
        //只查本部门员工
        let url = this.$tools.getURL(this.$urls.projectExecute.get_task_worker_list, { leader_type: Number(this.query.leader_type) });
        this.$axios.get(url).then(res => {
          this.config.staff_list = res.data;
          this.loadingData = false;
          resolve(true);
        }).catch(() => {
          this.$tips.error({ text: "获取Leader列表失败" });
          this.loadingData = false;
          reject(false);
        })
      })
    },
    async loadData(id) {
      //跨部门页面一定有数据
      this.loadingData = true;
      let url = this.$tools.getURL(this.$urls.projectExecute.get_task_work_detail, { id: id,leader_type:this.query.leader_type });
      this.$axios.get(url).then(async (res) => {
          this.loadingData = false;
          this.data = res.data;
          this.created_time = res.data.created_time?new Date(res.data.created_time).getTime():new Date().getTime();
          if(this.$tools.isNewProjectExe2(this.created_time)){
            this.config.projectType = this.$config.types.newProjectDemandType;
          }else{
            this.config.projectType = this.$config.types.projectDemandType;
          }
          // this.data.leaders = res.data.leaders.filter(x=>x.leader_type == Number(this.query.leader_type))
          this.subTaskData = res.data.sub_task;
          this.requirement_attachment = res.data.requirement_attachment?res.data.requirement_attachment.split(","):[];
          this.data.project_number = res.data.project_number;
      }).catch((err) => {
          this.loadingData = false;
          console.log(err);
      });
    },
    onCreated(editor,key) {
        this.editor[key] = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
        this.editor[key].disable();
    },
    //新增leader
    addLeader() {
      if(!this.isPrincipal) return;
      let leaders =
      {
        leader_type: "",
        user_id: "",
        remark: "",
      }
      this.data.leaders.push(leaders);
    },

    //删除leader
    delLeader(index) {
      if(!this.isPrincipal) return;
      this.data.leaders.splice(index, 1)
    },
    // doClose(){
    //     this.$emit('doClose')
    // },
    // 上传附件
    changeFile(res) {
      if (res.index != 0) {
        this.requirement_attachment.splice(res.index - 1, 1,...res.data.data);
      }else{
        this.requirement_attachment = this.requirement_attachment.concat(res.data.data);
      }
      this.data.requirement_attachment = this.requirement_attachment.join(",");
    },
    // 删除附件
    deleteFile(res) {
      this.requirement_attachment.splice(res.index, 1);
      this.data.requirement_attachment = this.requirement_attachment.join(",");
    },
    verifyData() {
      let emptyLeader = this.data.leaders.filter(x=>x.leader_type===""||x.user_id==="");
      if(emptyLeader.length > 0){
        this.$tips.error({ text: '请删除Leader类型或Leader姓名为空的Leader' });
        return false
      }
      let tempLeaderList = [];
      for (const leader of this.data.leaders) {
        let tempLeader = tempLeaderList.find(x=>x.leader_type === leader.leader_type && x.user_id === leader.user_id)
        if(tempLeader){
          this.$tips.error({ text: '含有重复的的Leader，请检查' });
          tempLeaderList = [];
          return false
        }else{
          tempLeaderList.push({leader_type:leader.leader_type,user_id:leader.user_id});
        }
      }
      return true;
    },
    doSendEmail(){
      if (this.loadingData || !this.verifyData()) {
        return;
      }
      let data = {
        task_id: this.query.id,
        specify_leader:this.data.specify_leader,
        operation_url:window.location.href,
        leaders:this.data.leaders.map(x=>{return {
          user_id:x.user_id,
          leader_type:x.leader_type,
          remark:x.remark
        }})
      };
      // console.log(data)
      this.loadingData = true;
      this.$axios.post(this.$urls.projectExecute.send_task_email,data).then(()=>{
        this.$tips.success({text:"发送任务邮件完成"})
        this.loadingData = false;
      }).catch((err)=>{
        console.log(err)
        this.$tips.error({text:"发送任务邮件失败"})
        this.loadingData = false;
      })
    }
  },

}
</script>
<style>
.projectAssignLeader_page_middle_content{
  flex: 1 0 0;
  width: 100%;
  position: relative;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  overflow: scroll;
}
.projectAssignLeader_page_middle_row_value {
  flex: 1 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.page_middle_row_attachment_key {
  flex: 24vw 0 0;
  text-align: right;
  margin-right: 2vw;
}

.project_execute_page_middle_row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 2vw;
}

.leader_select {
  width: 40vw !important;
}

.operation_icon {
  flex: 16vw 0 0;
  display: flex;
  justify-content: space-between;
  padding: 0 2vw;
}

.add_operation_icon i {
  color: #3e94e5;
  font-size: 4.5vw;
  flex: 1 0 0;
}

.del_operation_icon i {
  color: red;
  font-size: 4.5vw;
  flex: 1 0 0;
}
.page_middle_buttongroup {
  height: 16vw;
  position: relative;
  /* z-index:1000; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw 0;
}
.page_middle_buttongroup .el-button{
  padding: 2vw;
}
.project_exe_radio_input{
  width: 30vw !important;
  /* flex: 30vw 0 0; */
  border: none;
}
.projectAssignLerder_table{
  width: 100%;
}
.projectAssignLerder_table_tr{
  display: flex;
  width: 100%;
  margin-top: 1vw;
}
.projectAssignLerder_table_tr div{
  height: 10.8vw;
  /* border: 1px solid #a1a1a1; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.projectAssignLerder_table_leader{
  flex: 30vw 0 0;
}
.projectAssignLerder_table_name{
  flex: 1 0 0;
  padding: 0 1vw;
}
.projectAssignLerder_table_remark{
  flex: 25vw 0 0;
}
.projectAssignLerder_table_controls{
  flex: 10vw 0 0;
}
</style>